<a class="text-link-content" [routerLink]="url" [queryParams]="queryParams" [class.disable]="!url" [class.archived]="state === TrainingAvailability.ARCHIVED">
  <mat-icon *ngIf="state === TrainingAvailability.ARCHIVED" class="size-sm">archive</mat-icon>
  <span *ngIf="text && (text.length < 80)">{{ text }}</span>
  <span *ngIf="text && (text.length >= 80)" [matTooltip]="text" [matTooltipPosition]="'above'">{{ trimText(text) }}</span>
  <mat-icon class="text-link-icon">call_received</mat-icon>
</a>
